import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { Provider } from 'react-redux'
import { I18nextProvider } from 'react-i18next'
import { RouterProvider } from 'react-router-dom'
import ToastComponent from './components/common/ToastComponent'
import LoadingComponent from './components/common/LoadingComponent'
import { router } from './router/routes'
import i18n from './i18n'
import { store } from './store'
import reportWebVitals from './reportWebVitals'
import './index.scss'
import { AuthorizationHandler } from './store/authorizationHandler'

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  //integrations: [new BrowserTracing()],
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development',
  tracesSampleRate: 1.0,
  integrations: [
    Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      colorScheme: "system",
      label: "Feedback",
      triggerLabel: "Send feedback",
      formTitle: "Feedback",
      showBranding: false,
      showFeedbackButton: true,
      showReportDialog: true,
      confirmButtonLabel: "Submit",
      events: {
        click: true,
        mouseover: true,
      },
      user: {
        name: AuthorizationHandler.userName || "User",
        email: AuthorizationHandler.userEmail || "",
      },
    }),
  ],
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <LoadingComponent />
        <ToastComponent />
        <RouterProvider router={router} />
      </I18nextProvider>
    </Provider>
  </Sentry.ErrorBoundary>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
